import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AlbumProvider } from './contexts/AlbumContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Album from './pages/Album';
import CreateAlbum from './pages/CreateAlbum';
import PublicAlbum from './pages/PublicAlbum';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <AlbumProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/create-album" element={<CreateAlbum />} />
              <Route path="/album/:id" element={<Album />} />
              <Route path="/share/:shareId" element={<PublicAlbum />} />
            </Routes>
          </Layout>
        </Router>
      </AlbumProvider>
    </AuthProvider>
  );
}

export default App;